import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"esteman"> = {
  appId: "esteman",
  cookiePrefix: "es",
  lang: "ES",
  artist: {
    name: "Esteman & Daniela Spalla"
  },
  meta: {
    description: "Esteman & Daniela Spalla"
  },
  emailSender: {
    name: "Esteman & Daniela Spalla",
    email: "esteman-danielaspalla@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x5b3b600a36372bdec63b8a188408b55464a4d928"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(0)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: null,
  socialLinks: [
    { platform: SocialPlatform.Youtube, href: "https://www.pasaporteamorio.com/links", label: "YouTube" },
    { platform: SocialPlatform.Instagram, href: "https://www.pasaporteamorio.com/links", label: "Instagram" },
    { platform: SocialPlatform.TikTok, href: "https://www.pasaporteamorio.com/links", label: "TikTok" },
    { platform: SocialPlatform.Spotify, href: "https://www.pasaporteamorio.com/links", label: "Spotify" },
    {
      platform: SocialPlatform.AppleMusic,
      href: "https://www.pasaporteamorio.com/links",
      label: "Apple Music"
    }
  ],
  joinProof: {
    name: "Pasaporte Amorío",
    get assets() {
      return {
        backgroundImage: `${appConfig.s3.assets.appUrl}/join-proof.png`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        icon: `${appConfig.s3.assets.appUrl}/join-proof-icon.png`,
        image: `${appConfig.s3.assets.appUrl}/join-proof.png`,
        thumbnail: `${appConfig.s3.assets.appUrl}/join-proof.png`
      }
    }
  },
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 115
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 115
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
